export enum SpecialType {
  Property = '1',
  Floorplan = '2',
  UnitType = '3',
  UnitSpace = '4',
}
